import React, { useState } from 'react';
import './rainrate.scss';

const rgbaArrToStr = (rgbaArr) =>
	rgbaArr.reduce((acc, curr) => {
		return `${acc}rgba(${curr[0]}, ${curr[1]}, ${curr[2]}, ${curr[3]}),`;
	}, '');

const GradientBar = ({ values }) => {
	return (
		<div
			className="gradient-bar"
			data-testid={'rr-gradient-bar'}
			style={{
				background: `linear-gradient(${rgbaArrToStr(values.map(({ rgba }) => rgba)).replace(/,\s*$/, '')}), url()`,
			}}
		/>
	);
};

const InfoIconSvg = ({ onClick }) => (
	<span
		role="button"
		tabIndex={0}
		onClick={onClick}
		onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ' ? onClick?.() : null)}
		className="rr-on-hover"
		id="rr-info-icon"
		data-testid="rr-info-icon"
		aria-label="Show rain rate info"
	>
		<svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.2685 2.26947C15.9841 1.7293 18.7993 2.00584 21.3574 3.06537C23.9154 4.12496 26.1022 5.91947 27.6406 8.22162C29.1789 10.5239 29.9999 13.231 30 15.9999C30 19.713 28.5249 23.2738 25.8994 25.8994C23.2739 28.5249 19.713 29.9999 16 29.9999C13.231 29.9999 10.5239 29.1789 8.22163 27.6406C5.91947 26.1022 4.12497 23.9154 3.06538 21.3574C2.00585 18.7993 1.72931 15.9841 2.26948 13.2685C2.80972 10.5529 4.14268 8.05839 6.10054 6.10053C8.05839 4.14267 10.5529 2.80971 13.2685 2.26947ZM16 3.99994C13.6266 3.99995 11.3063 4.70384 9.33296 6.0224C7.35965 7.34098 5.82126 9.21549 4.91304 11.4081C4.00498 13.6006 3.76752 16.0133 4.23042 18.3408C4.69344 20.6685 5.8364 22.8071 7.5146 24.4853C9.19283 26.1635 11.3314 27.3065 13.6591 27.7695C15.9867 28.2324 18.3992 27.9949 20.5917 27.0869C22.7844 26.1786 24.6589 24.6403 25.9775 22.6669C27.2961 20.6935 28 18.3733 28 15.9999C27.9999 12.8174 26.7357 9.76501 24.4853 7.51459C22.2349 5.26419 19.1825 3.99994 16 3.99994ZM17 21.9999H20V23.9999H12V21.9999H15V15.9999H13V13.9999H17V21.9999ZM16 7.99994C16.3978 7.99994 16.7792 8.15812 17.0605 8.4394C17.3418 8.72069 17.4999 9.10214 17.5 9.49994C17.5 9.79654 17.4118 10.0863 17.247 10.333C17.0822 10.5796 16.8482 10.7721 16.5742 10.8857C16.3001 10.9992 15.998 11.0295 15.707 10.9716C15.4161 10.9137 15.1491 10.7702 14.9394 10.5605C14.7297 10.3508 14.5872 10.0837 14.5292 9.79291C14.4714 9.50194 14.5007 9.19981 14.6142 8.92572C14.7278 8.65173 14.9203 8.41765 15.1669 8.25287C15.4136 8.08813 15.7034 7.99995 16 7.99994Z"
				fill="#023E65"
			/>
		</svg>
	</span>
);

const CloseButtonSvg = ({ onClick }) => (
  <button
    onClick={onClick}
    type="button"
    className="custom-modal-close-btn ms-auto rr-on-hover rr-info-cross"
    id="close-rr-icon"
    data-testid="close-rr-icon"
    aria-label="Close rain rate info"
  >
    <svg
      className="w-3 h-3"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
      />
    </svg>
    <span className="sr-only">Close modal</span>
  </button>
);

const InfoText = ({ expanded, onClick }) => (
	<div className="rr-info-text p-1">
		<CloseButtonSvg onClick={() => onClick(!expanded)} />
		<span className="rr-fade-in rr__bold text-[16px]" id="rr-info">
			Rain rate
		</span>
		<span className="rr-fade-in text-[14px]" id="rr-sub-info">
			mm per hour
		</span>
	</div>
);

const InfoBar = ({ expanded, onClick }) => {
	return expanded ? (
		<InfoText expanded={expanded} onClick={onClick} />
	) : (
		<InfoIconSvg onClick={() => onClick(!expanded)} />
	);
};

const KeyItem = ({ rgbaColorArr, keyText }) => (
	<div className="rr-key-item" data-testid="rr-key-item">
		<div
			className="rr-key-item-color"
			id="rain-key-color"
			style={{
				backgroundColor: `rgba(${rgbaColorArr[0]}, ${rgbaColorArr[1]}, ${rgbaColorArr[2]}, ${rgbaColorArr[3]})`,
			}}
		/>
		<span className="rr-key-item-text" id="rain-key-text">
			{keyText}
		</span>
	</div>
);

const Key = ({ values }) => (
	<div className="rr-key rr-fade-in text-[14px]" id="rr-key" data-testid="rr-key">
		{values.map(({ value, rgba }, i) => (
			<KeyItem key={`keyItem_${i}`} rgbaColorArr={rgba} keyText={value} />
		))}
	</div>
);

const RainRate = ({ keyMapping, defaultStartExpanded = false }) => {
	const [toggleExpanded, setToggleExpanded] = useState(defaultStartExpanded);
	const filteredKeyMapping = keyMapping.filter((item) => item.value !== '');

	return (
		<div
			className={`rr-wrapper rr-wrapper-transition ${toggleExpanded ? 'rr-wrapper__expanded' : ''}`}
		>
			<InfoBar expanded={toggleExpanded} onClick={setToggleExpanded} />
			<GradientBar values={keyMapping} />
			{toggleExpanded && <Key values={filteredKeyMapping} />}
		</div>
	);
};

export default RainRate;
